import {createUseStyles} from 'react-jss';
import setContrastColorBasedOnBackground from '../../../style-helper/setContrastColorBasedOnBackground';

export default createUseStyles({
  counter: {
    width: '33%',
    zIndex: 1,
    textDecoration: 'none',
  },
  counterContainer: {
    margin: [0, 'auto'],
    textAlign: 'center',
    width: props => (props.active || props.complete ? props.theme.progressBar.counterSize : props.theme.progressBar.counterSize + 6),
    backgroundColor: props => props.theme.core.background,
  },
  counterNumber: (props) => {
    const activeColor = props.theme.progressBar.colour;
    return ({
      display: 'flex',
      paddingTop: props.theme.progressBar.counterPaddingTop,
      paddingLeft: props.theme.progressBar.counterPaddingLeft,
      paddingBottom: props.theme.progressBar.counterPaddingBottom,
      alignItems: 'center',
      justifyContent: 'center',
      height: props.theme.progressBar.counterSize,
      margin: [0, 3],
      border: !props.theme.progressBar.hideCounterBorder && '2px solid #bebebe',
      borderRadius: '50%',
      textAlign: 'center',
      fontSize: props.theme.progressBar.counterFontSize || 'inherit',
      fontWeight: props.theme.core.boldFontWeight,
      color: '#bebebe',
      transition: 'color 0s linear',
  
      ...(props.active || props.complete) && ({
        color: setContrastColorBasedOnBackground(activeColor),
        borderColor: activeColor,
        backgroundColor: activeColor,
        margin: [0, 'auto'],
        transition: 'background-color 0.2s linear 0.7s, border-color 0.2s linear 0.7s, color 0.2s linear 0.7s',
      }),
      
      ...props.complete && ({
        paddingTop: 0,
        paddingLeft: 0,
        paddingBottom: 0,
      }),
      
      extend: props.active && ({
        animation: '$bounce 0.3s linear 0.9s',
      }),
    });
  },
  counterIcon: {
    fill: props => (setContrastColorBasedOnBackground(props.theme.progressBar.colour)),
    padding: props => (props.theme.progressBar.counterSize > 20 ? 3 : 1),
    animation: '$bounce 0.2s linear',
  },
  
  // Animation
  '@keyframes bounce': {
    '0%': {
      transform: 'scale(1)',
    },
    '33%': {
      transform: 'scale(0.9)',
    },
    '66%': {
      transform: 'scale(1.1)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
});
